<template>
  <div class="locale-switcher">
    <b-dropdown v-model="$i18n.locale" :text="$t(navLanguage)" class="language">
      <b-dropdown-item v-for="locale in locales" :key="locale.code" :value="locale.code" @click="switchLoc(locale.code)">
        {{ locale.name }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { getSupportedLocales } from '@/util/i18n/supported-locales'
export default {
  data: () => ({ locales: getSupportedLocales(), navLanguage: 'NAV.LANGUAGE' }),
  methods: {
    switchLoc(code) {
      this.$i18n.locale = code

      //switch veeValidate language
      this.locale = code
    }
  }
}
</script>

<style scoped>
.locale-switcher {
  text-align: center;
  padding: 0px;
  margin: 0px;
}

.language {
  padding-top: 5px;
}
</style>
